import React from "react";

export const ComponentToPrint = React.forwardRef<any, any>((props, ref) => {
  const { details } = props;
  return <div ref={ref} style={{"padding":"32px"}}>{details}</div>;
});
